export default {
  meta: {
    title: '门店分析',
  },
};
